import React from "react";
import { Container, Title, Description } from "./styles";
import PropTypes from "prop-types";

const Card = ({ image, title, description }) => (
	<Container>
		{title && <Title>{title}</Title>}
		{description && (
			<Description
				dangerouslySetInnerHTML={{ __html: description.html }}
			></Description>
		)}
	</Container>
);

Card.defaultProps = {
	title: null,
	description: null,
};

Card.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
};
export default Card;
